/* ============
 * Getters for the form module
 * ============
 *
 * The getters that are available on the
 * form module.
 */

export default {};
